import { Injectable } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { StubdataService } from './stubdata.service';
import { ApiService } from './api.service';
import { Store, State } from '@ngrx/store';
import { GoToPageF01 } from '../providers/actions/f01.actions';
import { GoToPageF02, SetF02ChartAndTableData, SetF02CashTableData, SetF02AspireInformation } from '../providers/actions/f02.actions';
import { GoToPageF03 } from '../providers/actions/f03.actions';
import { GoToPageF04, SetF04PastTransaction, SetF04DividendAccountSummary } from '../providers/actions/f04.actions';
import { GoToPageI01 } from '../providers/actions/i01.actions';
import { GoToPageIB01 } from '../providers/actions/ib01.actions';
import { GoToPageJ01 } from '../providers/actions/j01.actions';
import { GoToPageJ03 } from '../providers/actions/j03.actions';
import { GoToPageK02 } from '../providers/actions/k02.actions';
import { GoToPageM02 } from '../providers/actions/m02.actions';
import { GoToPageM03 } from '../providers/actions/m03.actions';
import { GoToPageH01, SetH01ChartAndTableData, SetFundManagerList, SetFundList, SetTransactionNo } from './actions/h01.actions';
import { GoToPageG01, SetSwitchInChartAndTableData, SetSwitchInFundManagerList, SetSwitchInFundList, SetSwitchInTransactionNo, SetG01PendingTransaction } from './actions/g01.actions';
import { SetUser } from './actions/user.actions';
import { SetTransactionStatus } from './actions/navigation.actions';
import * as _ from 'lodash';
import { GoToPageBG02 } from './actions/bg02.actions';
import { GoToPageBG07 } from './actions/bg07.actions';
import { GoToPageBG01 } from './actions/bg01.actions';
import { GoToPageBL01 } from './actions/bl01.actions';
import { GoToPageBL02 } from './actions/bl02.actions';
import { GoToPageBL03 } from './actions/bl03.actions';
import { GoToPageBL04 } from './actions/bl04.actions';
import { GoToPageBL05 } from './actions/bl05.actions';
import { GoToPageBL06 } from './actions/bl06.actions';
import { GoToPageBL07 } from './actions/bl07.actions';
import { GoToPageBK01 } from './actions/bk01.actions';
import { GoToPageBK02 } from './actions/bk02.actions';
import { GoToPageBK03 } from './actions/bk03.actions';
import { GoToPageBM01 } from './actions/bm01.actions';
import { GoToPageBG16 } from './actions/bg16.actions';
import { GoToPageBG20, UpdateBg20PendingTransaction, UpdateBg20AccountTable, UpdateBg20ContributionSummary, UpdateBg20TransactionHistory } from './actions/bg20.actions';
import { GoToPageBG06 } from './actions/bg06.actions';
import { PasswordEncryptionService } from './password-encryption.service';
import { TranslateService } from '@ngx-translate/core';
import { GoToPageR01 } from './actions/r01.actions';
import { environment } from '../../environments/environment';
import { CommonService } from '../services/common.service';

@Injectable({
  providedIn: 'root'
})
export class PageService {

  constructor(
    private stubdataService: StubdataService,
    private apiService: ApiService,
    private alertController: AlertController,
    public store: Store<any>,
    private state: State<any>,
    private loadingController: LoadingController,
    public translate: TranslateService,
    private passwordService: PasswordEncryptionService,
    private alertCtrl: AlertController,
    private commonService: CommonService,
  ) { }


  async a01_get_login_status(username, pwd, loginTime, salt) {
    try {
      const res = await this.apiService.apiCall(['/UserAccount/GetLoginStatus'], [{ username: username, pwd: pwd, loginTime: loginTime }]);
      const payload = {
        username: res[0]['data']['username'],
        sessionKey: res[0]['data']['sessionKey'],
        isLoggedIn: true,
        clientNo: res[0]['data']['clientNo'],
        greeting: res[0]['data']['lastName'] + ' ' + res[0]['data']['firstName'],
        emailAddress: this.passwordService.decryptFunc(res[0]['data']['email'], salt),
        pagesAllowed: res[0]['data']['pagesAllowed'],
        canGoToInvestPlatform : res[0]['data']['canGoToInvestPlatform']
      };
      // console.log('a01_get_login_status', res);
      this.updateStore('a01', payload);
      return res[0]['data']['isFirstLogin'] === 'Y';
    } catch (err) {
      console.log('a01_get_login_status err', err);
      this.presentAlert(err.response.status, err.response.data.errorMsg);
      throw err;
    }
  }

  get_transaction_status() {
    return this.state.getValue().navigation.transactionStatus;
  }

  set_transaction_status(status) {
    this.store.dispatch(new SetTransactionStatus(status));
  }

  async get_logout_status() {
    try {
      return await this.apiService.apiCall(['/UserAccount/GetLogoutStatus']);
    } catch (err) {
      console.log('get_logout_status err', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_finex_url(fundCode?) {
    try {
      let res: any;
      if (fundCode) {
        res = await this.apiService.apiCall(['/Content/GetFinexURL'], [{ fundCode: fundCode }]);
      } else {
        res = await this.apiService.apiCall(['/Content/GetFinexURL']);
      }
      return res[0]['data']['finexLink'];
    } catch (err) {
      console.log('get_finex_url err', err);
    }
  }

  get_morningStar_screener_url(fundCode?) {
    try {
      const language = this.state.getValue().setting.language;
      let res: any;
      let res2: any;

      if (fundCode) {
        res2 = this.apiService.apiCall(['/Content/GetMorningStarURL'], [{ fundCode: fundCode }]);
        res = res[0]['data']['morningStarLink'];
      } else {
        // res = environment.morningStar_screener_url + (language === 'tc' ? 'zh-HK' : 'en-GB');
        res = environment.publicsite_url + language + environment.morningStar_screener_url;
      }
      return res;
    } catch (err) {
      console.log('get_morningStar_url err', err);
    }
  }

  async get_token(system, clientID) {
    try {
      // const language = this.state.getValue().setting.language;
      let res: any;
      if (system === 'aqumon') {
        res = await this.apiService.apiCall(['/UserAccount/GenerateToken'], [{ clientID: clientID }]);
        res = res[0]['data']['token'];
      }
      console.log(res);
      return res;
    } catch (err) {
      console.log('get_token err', err);
    }
  }

  get_morningStar_comparison_url() {
    try {
      const language = this.state.getValue().setting.language;
      let res: any;
      // res = environment.morningStar_fund_comparison_url + (language === 'tc' ? 'zh-HK#?' : 'en-GB#?') + 'idType=msid&securityIds=F0GBR04AWT%7CF0GBR04SEX%7CFOGBR05KLK';
      res = environment.publicsite_url + language + environment.morningStar_fund_comparison_url + (language === 'tc' ? 'zh-HK#?' : 'en-GB#?');
      return res;
    } catch (err) {
      console.log('get_morningStar_url err', err);
    }
  }

  async bg01_get_policy_enquiry_list(filter?) {
    try {
      const res = await this.apiService.apiCall(['/PolicyInfoContent/GetPolicyEnquiryList'], [filter]);
      this.updateStore('bg01', res[0]['data']);
    } catch (err) {
      this.updateStore('bg01', {
        policyEnquiry: []
      });
      console.log('bg01_get_policy_enquiry_list err', err);
    }
  }

  async bg02_to_05_get_policy_enquiry_list(pageId, filter?) {
    try {
      const res = await this.apiService.apiCall(['/PolicyInfoContent/GetPolicyEnquiryList'], [
        {
          isInForce: pageId === 'bg02',
          isPending: pageId === 'bg03',
          isPolicyDue: pageId === 'bg04',
          isOverdue: pageId === 'bg05',
          ...filter
        }
      ]);
      const pagesAllowed = this.state.getValue().user.pagesAllowed;
      this.updateStore('bg02', {
        data: res[0]['data'],
        pagesAllowed: pagesAllowed
      });
    } catch (err) {
      console.log('bg02_to_05_get_policy_enquiry_list err', err);
      this.updateStore('bg02', {
        noOfRecords: 0,
        policyEnquiry: []
      });
    }
  }

  async bg02_search_get_product() {
    try {
      const res = await this.apiService.apiCall(['/PolicyInfoContent/GetProducts']);
      return res[0]['data']['productList'];
    } catch (err) {
      console.log('bg02_search_get_product err', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
    }
  }

  async bg03a_pending_policy_details(policyNo) {
    try {
      const res = await this.apiService.apiCall(['/PolicyInfoContent/GetPolicyPendingInfo', '/PolicyInfoContent/GetMyPolicies'], [{ policyNo: policyNo }, { policyNo: policyNo }]);
      res['policyPendingDetail'] = res[0]['data']['policyPendingDetail'];
      res['policy'] = res[1]['data']['policy'][0];
      return res;
    } catch (err) {
      console.log('bg03a_pending_policy_details err', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
    }
  }

  async bg06_get_policy_client_estatment_list(filter?) {
    try {
      const res = await this.apiService.apiCall(['/PolicyInfoContent/GetPolicyEstatementList'], [filter]);
      this.updateStore('bg06', res[0]['data']);
    } catch (err) {
      console.log('bg06_get_policy_client_estatment_list err', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      this.updateStore('bg06', {
        policyEStatement: []
      });
      throw err;
    }
  }

  async bg07_get_birthday_list(policyNoOrCustomerName?) {
    try {
      let res: any = [];
      if (policyNoOrCustomerName) {
        res = await this.apiService.apiCall(['/ClientInfoContent/GetClientBirthdayList'], [{ policyNoOrCustomerName: policyNoOrCustomerName }]);
      } else {
        res = await this.apiService.apiCall(['/ClientInfoContent/GetClientBirthdayList']);
      }
      this.updateStore('bg07', res[0]['data']['clientBirthdayInfo']);
    } catch (err) {
      console.log('bg07_get_birthday_list err', err);
      // this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      this.updateStore('bg07', []);
    }
  }

  async bg08_12_validate_policy_number(policyNo, listType) {
    try {
      const res = await this.apiService.apiCall(['/FundTransactions/ValidatePolicyNumber'], [{
        policyNo: policyNo,
        listType: listType
      }]);
      return res[0]['data']['returnStatus']['status'] === '0';
    } catch (err) {
      console.log('bg08_validate_policy_number', err);
      // Fixed workitem 564
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
    }
  }

  async bg08_12_get_my_policies(policyNo) {
    try {
      const res = await this.apiService.apiCall(['/PolicyInfoContent/GetMyPolicies'], [{ policyNo: policyNo }]);
      return res[0]['data']['policy'][0];
    } catch (err) {
      console.log('bg08_validate_policy_number', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
    }
  }

  async bg16_get_transaction_history(filter?) {
    try {
      const res = await this.apiService.apiCall(['/PolicyInfoContent/GetTransactionHistory'], [filter]);
      this.updateStore('bg16', res[0]['data']);
    } catch (err) {
      console.log('bg16_get_transaction_history', err);
      this.updateStore('bg16', []);
    }
  }

  async bg16_get_my_policy(policyNo) {
    try {
      const res = await this.apiService.apiCall(['/PolicyInfoContent/GetMyPolicies'], [{ policyNo: policyNo }]);
      return res[0]['data']['policy'][0]['policyInfoView'];
    } catch (err) {
      console.log('bg16_get_my_policy', err);
      return {};
    }
  }

  async bg16_get_transaction_records_for_past_12_months(policyNo) {
    try {
      // Fixed wirkitem 407
      // const res = await this.apiService.apiCall(['/PolicyInfoContent/GetTransactionRecordsForPreviousTwelveMonths'], [{ policyNo: policyNo }]);
      const res = await this.apiService.apiCall(['/PolicyInfoContent/GetTransactionRecords'], [{ policyNo: policyNo }]);
      return res[0]['data'];
    } catch (err) {
      console.log('bg16_get_transaction_records_for_past_12_months', err);
      return {};
    }
  }

  async bg20_get_my_policies(policyNo?) {
    try {
      const res = await this.apiService.apiCall(['/PolicyInfoContent/GetMyPolicies'], [{ policyNo: policyNo }]);
      this.updateStore('bg20', res[0]['data']);
    } catch (err) {
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      console.log('bg20_get_my_policies', err);
    }
  }

  async bg20_get_policy_contribution(policyNo) {
    try {
      const res = await this.apiService.apiCall(['/PolicyInfoContent/GetPolicyContributions'], [{ policyNo: policyNo }]);
      this.updateStore('bg20-update-contribution-summary', res[0]['data']);
    } catch (err) {
      console.log('bg20_get_policy_contribution', err);
    }
  }

  async bg20_get_pending_policy(policyNo) {
    try {
      const res = await this.apiService.apiCall(['/PolicyInfoContent/GetPendingTransactions'], [{ policyNo: policyNo }]);
      this.updateStore('bg20-update-pending-transaction', res[0]['data']['policyPendingTransactionsList']);
    } catch (err) {
      console.log('bg20_get_pending_policy', err);
      this.updateStore('bg20-update-pending-transaction', []);
    }
  }

  async bg20_get_account_table(policyNo, coverageNo, accountType) {
    try {
      const res: any = await this.apiService.apiCall(['/PolicyInfoContent/GetPolicyClientIncentiveList', '/PolicyInfoContent/GetPolicyCoverageBalanceList', '/PolicyInfoContent/GetMyPolicies'], [{ policyNo: policyNo, coverageNo: coverageNo, accountType: accountType }, { policyNo: policyNo, coverageNo: coverageNo, accountType: accountType }, { policyNo: policyNo }]);
      res[2]['data']['selectedAccount'] = { policyAcctNo: coverageNo, policySubAcctNo: accountType };
      this.updateStore('bg20-update-account-table', res.map(e => e['data']));
    } catch (err) {
      console.log('');
    }
  }

  async bg20_get_date_range_for_searching_transaction_history() {
    try {
      const res: any = await this.apiService.apiCall(['/Content/GetDateRangeForSearchingTransactionHistory']);
      return res[0]['data'];
    } catch (err) {
      console.log(err);
    }
  }

  async bg20_get_policy_fund_transaction_history(policyNo, coverageNo, accountType, searchFromDate, searchToDate) {
    try {
      const res: any = await this.apiService.apiCall(['/PolicyInfoContent/GetPolicyFundTransactionHistory'], [{
        policyNo: policyNo,
        coverageNo: coverageNo,
        accountType: accountType,
        searchFromDate: searchFromDate,
        searchToDate: searchToDate
      }]);
      this.updateStore('bg20-update-policy-fund-transaction-history', res[0]['data']);
    } catch (err) {
      console.log(err);
    }
  }

  async downloadPDF(policyNo, coverageNo, accountType, pageID, isBrokerSite, searchFromDate, searchToDate) {
    console.log(`Download PDF: `);
    try {
      if (searchFromDate === '' && searchToDate === '') {
        const res: any = await this.apiService.apiCall([
          '/PolicyInfoContent/GeneratePDF'
        ], [{ policyNo: policyNo, coverageNo: coverageNo, accountType: accountType, pageID: pageID, isBrokerSite: isBrokerSite }]);
        return res[0]['data'];
      } else if (searchFromDate !== '' && searchToDate === '') {
        const res: any = await this.apiService.apiCall([
          '/PolicyInfoContent/GeneratePDF'
        ], [{ policyNo: policyNo, coverageNo: coverageNo, accountType: accountType, pageID: pageID, isBrokerSite: isBrokerSite, searchFromDate: searchFromDate }]);
        return res[0]['data'];
      } else if (searchFromDate === '' && searchToDate !== '') {
        const res: any = await this.apiService.apiCall([
          '/PolicyInfoContent/GeneratePDF'
        ], [{ policyNo: policyNo, coverageNo: coverageNo, accountType: accountType, pageID: pageID, isBrokerSite: isBrokerSite, searchToDate: searchToDate }]);
        return res[0]['data'];
      } else if (searchFromDate !== '' && searchToDate !== '') {
        const res: any = await this.apiService.apiCall([
          '/PolicyInfoContent/GeneratePDF'
        ], [{ policyNo: policyNo, coverageNo: coverageNo, accountType: accountType, pageID: pageID, isBrokerSite: isBrokerSite, searchFromDate: searchFromDate, searchToDate: searchToDate }]);
        return res[0]['data'];
      }
    } catch (err) {
      console.log(`Download PDF err: `, err);
      return null;
    }
  }

  async get_file_content(filePath) {
    try {
      const res = await this.apiService.apiCall(['/Content/GetFileContent'], [{ filePath: filePath }]);
      return res[0]['data'];
    } catch (err) {
      console.log('get_file_content', err);
      throw err;
    }
  }

  get_zipfile_content(filePath) {
    try {
      return this.apiService.apiCall(['/Content/GetZipFile'], [{ filePath: filePath }]);
      // return res[0]['data'];
    } catch (err) {
      console.log('get_file_content', err);
      throw err;
    }
  }

  async bh_get_files(filter) {
    let pleaseWaitMessage = 'Please wait...';
    this.translate.get(['GEN_01']).subscribe(i18n => {
      pleaseWaitMessage = i18n.GEN_01;
    });
    const loader = await this.loadingController.create({
      message: pleaseWaitMessage
    });
    try {
      loader.present();
      const res = await this.apiService.apiCall(['/Content/GetFiles'], [filter]);
      console.log('bh_get_files', res);
      loader.dismiss();
      return res[0]['data'];
    } catch (err) {
      console.log('bh02_get_files', err);
      loader.dismiss();
      return null;
    }
  }

  async bh02_get_commission_statement(file_name) {
    try {
      const res = await this.apiService.apiCall(['/Content/GetCommissionStatement'], [{ fileName: file_name }]);
      return res[0]['data'];
    } catch (err) {
      console.log('bh02_get_commission_statement', err);
      return null;
    }
  }

  async bh05_get_files() {
    let pleaseWaitMessage = 'Please wait...';
    this.translate.get(['GEN_01']).subscribe(i18n => {
      pleaseWaitMessage = i18n.GEN_01;
    });
    const loader = await this.loadingController.create({
      message: pleaseWaitMessage
    });
    // Fixed workitem #534
    // Comment out try and catch in order to not fall to error
    // Also check the list to be null and assign to empty list
    // try {
    loader.present();
    let new_business_list, service_letter_list, other_list;
    // try {
    new_business_list = await this.apiService.apiCall(['/Content/GetFiles'], [{
      statementType: 'S',
      isNewBusiness: true
    }]);
    // } catch (err) { }

    // try {
    service_letter_list = await this.apiService.apiCall(['/Content/GetFiles'], [{
      statementType: 'S',
      isServicingLetters: true
    }]);
    // } catch (err) { }

    // try {
    other_list = await this.apiService.apiCall(['/Content/GetFiles'], [{
      statementType: 'S',
      isOthers: true
    }]);
    // } catch (err) { }

    loader.dismiss();

    return {
      /* new_business_list: new_business_list[0]['data']['otherFileInfoList'],
      service_letter_list: service_letter_list[0]['data']['otherFileInfoList'],
      other_list: other_list[0]['data']['otherFileInfoList'] */
      new_business_list: new_business_list[0]['data']['otherFileInfoList'] !== null ? new_business_list[0]['data']['otherFileInfoList'] : [],
      service_letter_list: service_letter_list[0]['data']['otherFileInfoList'] !== null ? service_letter_list[0]['data']['otherFileInfoList'] : [],
      other_list: other_list[0]['data']['otherFileInfoList'] !== null ? other_list[0]['data']['otherFileInfoList'] : []
    };
    /* } catch (err) {
      console.log('bh02_get_files', err);
      loader.dismiss();
      return {
        new_business_list: [],
        service_letter_list: [],
        other_list: []
      };
    } */
  }

  async get_bl01_service_center() {
    try {
      const result = [];
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFiles']);
        result.push(res[0]['data']);
      } catch (err) {
        result.push([]);
      }
      try {
        const res = await this.apiService.apiCall(['/Content/GeteSQSURL']);
        result.push(res[0]['data']);
      } catch (err) {
        result.push(null);
      }
      this.updateStore('bl01', {
        pdf: result[0],
        url: result[1]
      });
    } catch (err) {
      console.log('get_bl01_service_center', err);
    }
  }

  async get_bl02_service_center_application() {
    try {
      let pleaseWaitMessage = 'Please wait...';
      this.translate.get(['GEN_01']).subscribe(i18n => {
        pleaseWaitMessage = i18n.GEN_01;
      });
      const loader = await this.loadingController.create({
        message: pleaseWaitMessage
      });
      const result = [];
      loader.present();
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForApplicationInfo'], [{ isGeneral: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForApplicationInfo'], [{ isAspiration: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForApplicationInfo'], [{ isFortuity: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForApplicationInfo'], [{ isAddendium: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForApplicationInfo'], [{ isServicing: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForApplicationInfo'], [{ isUnderwritingQuestionnaire: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForApplicationInfo'], [{ isCies: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      loader.dismiss();
      this.updateStore('bl02', result);
    } catch (err) {
      console.log('get_bl02_service_center_application', err);
    }
  }

  async get_bl03_service_center_management() {
    try {
      let pleaseWaitMessage = 'Please wait...';
      this.translate.get(['GEN_01']).subscribe(i18n => {
        pleaseWaitMessage = i18n.GEN_01;
      });
      const loader = await this.loadingController.create({
        message: pleaseWaitMessage
      });
      const result = [];
      loader.present();
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForPolicyManagementInfo'], [{ isAddendium: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForPolicyManagementInfo'], [{ isAssignment: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForPolicyManagementInfo'], [{ isAddingPhysicianStmt: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForPolicyManagementInfo'], [{ isServicing: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForPolicyManagementInfo'], [{ isDeclaration: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForPolicyManagementInfo'], [{ isClaims: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      loader.dismiss();
      this.updateStore('bl03', result);
    } catch (err) {
      console.log('get_bl03_service_center_management', err);
    }
  }

  async get_bl04_service_center_guidelines() {
    try {
      let pleaseWaitMessage = 'Please wait...';
      this.translate.get(['GEN_01']).subscribe(i18n => {
        pleaseWaitMessage = i18n.GEN_01;
      });
      const result = [];
      const loader = await this.loadingController.create({
        message: pleaseWaitMessage
      });
      loader.present();
      try {
        const res1 = await this.apiService.apiCall(['/Content/GetPDFFilesForGuidelines'], [{ isUnderwriting: true }]);
        result.push(res1[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res2 = await this.apiService.apiCall(['/Content/GetPDFFilesForGuidelines'], [{ isGuideline: true }]);
        result.push(res2[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res3 = await this.apiService.apiCall(['/Content/GetPDFFilesForGuidelines'], [{ isPolicyAdmin: true }]);
        result.push(res3[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res4 = await this.apiService.apiCall(['/Content/GetPDFFilesForGuidelines'], [{ isCustomerService: true }]);
        result.push(res4[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      loader.dismiss();
      this.updateStore('bl04', result);
    } catch (err) {
      console.log('get_bl04_service_center_guidelines', err);
    }
  }

  async get_bl05_service_center_provision() {
    try {
      const res = await this.apiService.apiCall([
        '/Content/GetPDFFiles'
      ], [
        { isPolicyProvision: true }
      ]);
      const storeRes = [];
      if (Array.isArray(res) && res.length > 0) {
        res.forEach(e => {
          storeRes.push(e.data);
        });
      }
      this.updateStore('bl05', storeRes);
    } catch (err) {
      console.log('get_bl05_service_center_provision', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
    }
  }

  async get_bl06_service_center_disable_broker(filter?) {
    try {
      const result = [];
      try {
        const res = await this.apiService.apiCall(['/ChannelContent/GetBrokerOrTRList'], [filter]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push(null);
      }
      try {
        const res = await this.apiService.apiCall(['/ChannelContent/GetRoles']);
        result.push(res[0]['data']);
      } catch (err) {
        result.push(null);
      }
      try {
        const res = await this.apiService.apiCall(['/ChannelContent/GetHierarchy']);
        result.push(res[0]['data']);
      } catch (err) {
        result.push(null);
      }
      this.updateStore('bl06', result);
    } catch (err) {
      console.log('get_bl06_service_center_disable_broker', err);
      throw err;
    }
  }

  async bl06_disable_broker(usernames) {
    try {
      const endpoints = [];
      // Fixed workitem 507
      // const args = [];
      const args = usernames.join(',');
      /* usernames.map(username => {
        endpoints.push('/ChannelTransactions/UpdateBrokerOrTRStatus');
        args.push(username);
      }); */
      // const res = await this.apiService.apiCall(endpoints, args);
      const res = await this.apiService.apiCall([
        '/ChannelTransactions/UpdateBrokerOrTRStatus'
      ], [{ userNameForBrokerOrTR: args }]);
      const storeRes = [];
      if (Array.isArray(res) && res.length > 0) {
        res.forEach(e => {
          storeRes.push(e.data);
        });
      }
      if (res[0]['data']['status'] === '0') {
        return res[0]['data']['errorMsg'];
      }
    } catch (err) {
      console.log('bl06_disable_broker', err);
      throw err;
    }
  }

  async get_bl07_service_center_investment() {
    try {
      let pleaseWaitMessage = 'Please wait...';
      this.translate.get(['GEN_01']).subscribe(i18n => {
        pleaseWaitMessage = i18n.GEN_01;
      });
      const loader = await this.loadingController.create({
        message: pleaseWaitMessage
      });
      const result = [];
      loader.present();
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForProInvestorInfo'], [{ isPolicyProvision: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForProInvestorInfo'], [{ isCSGuideline: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      try {
        const res = await this.apiService.apiCall(['/Content/GetPDFFilesForProInvestorInfo'], [{ isServicing: true }]);
        result.push(res[0]['data']);
      } catch (err) {
        result.push({
          returnStatus: {},
          pdfFilesInfo: []
        });
      }
      loader.dismiss();
      this.updateStore('bl07', result);
    } catch (err) {
      console.log('get_bl07_service_center_investment', err);
    }
  }

  async get_bk01_tools() {
    try {
      //  We would need to get the first 5 PDF files for marketing commentary.
      //  This is done by an iterative approach of performing API calls.
      //  Continue iteration if amount retrieved < 5 or list not yet fully retrieved.

      //  index stores the current iteration; len stores the amount of PDF files found.
      let index = 0, amount = 0;

      const conditions = [
        { isGlobalMarketOutlook: true },
        { isMonthlyMarketUpdate: true },
        { isStandardLifeInvestment: true },
        { isAberdeenInternational: true },
        { isBaringAsset: true },
        { isBlackRock: true },
        { isBNP: true },
        { isFidelity: true },
        { isFastState: true },
        { isFranklin: true },
        { isJPMorgan: true },
        { isSchrodar: true }
      ];
      const storeRes = [];
      do {
        const res = await this.apiService.apiCall([
          '/Content/GetPDFFilesForMarketingCommentary'
        ], [
          conditions[index]
        ]);

        if (Array.isArray(res) && res.length > 0) {
          res.forEach(e => {
            storeRes.push(e.data);
            amount += e.data.pdfFilesInfo.length;
          });
        }
        index++;
      } while (amount < 5 && index < conditions.length);

      this.updateStore('bk01', storeRes);
    } catch (err) {
      console.log('get_bk01_tools', err);
    }
  }

  async get_bk02_tools_market_commentary() {
    try {
      const res = await this.apiService.apiCall([
        '/Content/GetPDFFilesForMarketingCommentary',
        '/Content/GetPDFFilesForMarketingCommentary',
        '/Content/GetPDFFilesForMarketingCommentary',
        '/Content/GetPDFFilesForMarketingCommentary',
        '/Content/GetPDFFilesForMarketingCommentary',
        '/Content/GetPDFFilesForMarketingCommentary',
        '/Content/GetPDFFilesForMarketingCommentary',
        '/Content/GetPDFFilesForMarketingCommentary',
        '/Content/GetPDFFilesForMarketingCommentary',
        '/Content/GetPDFFilesForMarketingCommentary',
        '/Content/GetPDFFilesForMarketingCommentary',
        '/Content/GetPDFFilesForMarketingCommentary'
      ], [
        { isGlobalMarketOutlook: true },
        { isMonthlyMarketUpdate: true },
        { isStandardLifeInvestment: true },
        { isAberdeenInternational: true },
        { isBaringAsset: true },
        { isBlackRock: true },
        { isBNP: true },
        { isFidelity: true },
        { isFastState: true },
        { isFranklin: true },
        { isJPMorgan: true },
        { isSchrodar: true }
      ]);
      const storeRes = [];
      if (Array.isArray(res) && res.length > 0) {
        res.forEach(e => {
          storeRes.push(e.data);
        });
      }
      this.updateStore('bk02', storeRes);
    } catch (err) {
      console.log('get_bk02_tools_market_commentary', err);
    }
  }
  async get_bk03_tools_education_series() {
    try {
      const res = await this.apiService.apiCall([
        '/Content/GetPDFFiles',
        '/Content/GetPDFFiles',
        '/Content/GetPDFFiles'
      ], [
        { isTipsForInternationalClients: true },
        { isTipsForLocalClients: true },
        { isInvestmentBasis: true }
      ]);
      const storeRes = [];
      if (Array.isArray(res) && res.length > 0) {
        res.forEach(e => {
          storeRes.push(e.data);
        });
      }
      this.updateStore('bk03', storeRes);
    } catch (err) {
      console.log('get_bk03_tools_education_series', err);
    }
  }
  async get_bm01_broker_communication() {
    try {
      const res = await this.apiService.apiCall([
        '/Content/GetPDFFilesForBrokerCommunication',
        '/Content/GetPDFFilesForBrokerCommunication',
        '/Content/GetPDFFilesForBrokerCommunication',
        '/Content/GetPDFFilesForBrokerCommunication'
      ], [
        { isProductAndPromotion: true },
        { isOperations: true },
        { isInvestmentChoice: true },
        { isMarketUpdate: true }
      ]);
      const storeRes = [];
      if (Array.isArray(res) && res.length > 0) {
        res.forEach(e => {
          storeRes.push(e.data);
        });
      }
      this.updateStore('bm01', storeRes);
    } catch (err) {
      console.log('get_bm01_broker_communication', err);
    }
  }

  async b01_validate_policy_no(policyNo) {
    try {
      return await this.apiService.apiCall(['/UserTransactions/SignUp_ValidatePolicyNo'], [{ policyNo: policyNo }]);
    } catch (err) {
      console.log('b01_validate_policy_no err', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async b02_original_validate_personal_info(payload) {
    try {
      return await this.apiService.apiCall(['/UserTransactions/SignUp_Original_ValidatePersonalInfo'], [payload]);
    } catch (err) {
      console.log('b02_original_validate_personal_info err', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async c01_forget_password(payload) {
    try {
      return await this.apiService.apiCall(['/UserTransactions/ForgotPassword'], [payload]);
    } catch (err) {
      console.log('c01_forget_password err', err);
      this.presentAlert(err.response.status, err.response.data.errorMsg);
      throw err;
    }
  }

  async d01_forget_user_id(emailAdd, dateOfBirth, idNo) {
    try {
      return await this.apiService.apiCall(['/UserTransactions/ForgotUserID'], [{ emailAdd: emailAdd, dateOfBirth: dateOfBirth, idNo: idNo }]);
    } catch (err) {
      console.log('d01_forget_user_id err', err);
      this.presentAlert(err.response.status, err.response.data.errorMsg);
      throw err;
    }
  }

  async get_f01_my_wealth() {
    try {
      const res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetMyPolicies',
        // '/PolicyInfoContent/GetPolicyCoverageBalanceList'
      ]);
      const storeRes = [];
      res.forEach(e => {
        storeRes.push(e.data);
      });
      this.updateStore('f01', storeRes);
    } catch (err) {
      console.log(`get_f01_my_wealth err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_f02_policy_summary(policyNo) {
    try {
      const res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetMyPolicies',
      ], [{ policyNo: policyNo }]);
      // console.log('GetMyPolicies f02',policyNo, res);
      this.updateStore('f02', res.map(e => e.data));
    } catch (err) {
      console.log(`get_f02_policy_summary err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_f02_cash_account(policyNo, coverageNo, accountType) {
    try {
      let res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetPolicyCashAccountBalanceList',
      ], [{ policyNo: policyNo, coverageNo: coverageNo, accountType: accountType }]);
      res = res.map(e => e.data);
      console.log('GetPolicyCashAccountBalanceList f02', res);
      this.updateStore('f02-update-cash-table', { chartData: res[0] });
    } catch (err) {
      console.log(`get_f02_cash_account err: `, err);
      // this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      this.updateStore('f02-update-cash-table', {
        chartData: []
      });
      // throw err;
    }
  }

  async get_f02_chart_and_table(policyNo, coverageNo, accountType) {
    try {
      let res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetPolicyCoverageFundAllocationList',
        '/PolicyInfoContent/GetPolicyCoverageBalanceList',
        '/PolicyInfoContent/GetPolicyCoverageBalanceListForCashAccountAndNonCashAccount'
      ],
        [
          { policyNo: policyNo, coverageNo: coverageNo },
          { policyNo: policyNo, coverageNo: coverageNo, accountType: accountType },
          { policyNo: policyNo, coverageNo: coverageNo, accountType: accountType }
        ]);
      res = res.map(e => e.data);
      this.updateStore('f02-update-chart-and-table', {
        tableData: res[0],
        chartData: res[1],
        newChartData: res[2]
      });
    } catch (err) {
      console.log('get_f02_chart_and_table', err.response.status);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      this.updateStore('f02-update-chart-and-table', {
        tableData: [],
        chartData: [],
        newChartData: []
      });
      // throw err;
    }
  }

  async get_f02_aspire_or_aspiration_information(policyNo) {
    try {
      const res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetPolicyExtraAllocationDetailForAspireOrAspiration'
      ], [{ policyNo: policyNo }]);
      this.updateStore('f02-aspire-information', res.map(e => e.data));
    } catch (err) {
      console.log(`get_f02_aspire_or_aspiration_information err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_f03_policy_information(policy_no) {
    console.log(`get_f03_policy_informations: `);
    let pleaseWaitMessage = 'Please wait...';
    this.translate.get(['GEN_01']).subscribe(i18n => {
      pleaseWaitMessage = i18n.GEN_01;
    });
    const loader = await this.loadingController.create({
      message: pleaseWaitMessage
    });
    try {
      const policies: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetMyPolicies'
      ], [{ policyNo: policy_no }]);

      // Fixed workitem 78
      const jointInsuredNo = policies[0]['data']['policy'].map(policy => {
        return {
          policyNo: {
            jointInsuredCode: policy['policyInfoView']['jointInsuredCode']
          }
        };
      });

      if (jointInsuredNo.jointInsuredCode != null) {
        const policyNo = policies[0]['data']['policy'].map(policy => {
          return {
            policyNo: {
              ownerNo: policy['policyInfoView']['ownerNo'],
              insuredCode: policy['policyInfoView']['insuredCode'],
              // Fixed workitem 78
              jointInsuredCode: policy['policyInfoView']['jointInsuredCode']
            }
          };
        });
        const result = [];
        console.log('GetClientPersonalInfo policyNo', policyNo);
        loader.present();
        for (const policy of policyNo) {
          try {
            const clientInfo = {};
            // Fixed workitem 78
            // const res = await this.apiService.apiCall(['/ClientInfoContent/GetClientPersonalInfo', '/ClientInfoContent/GetClientPersonalInfo'], [{clientNo: policy.policyNo.ownerNo}, {clientNo: policy.policyNo.insuredCode}]);
            const res = await this.apiService.apiCall(['/ClientInfoContent/GetClientPersonalInfo', '/ClientInfoContent/GetClientPersonalInfo', '/ClientInfoContent/GetClientPersonalInfo'], [{ clientNo: policy.policyNo.ownerNo }, { clientNo: policy.policyNo.insuredCode }, { clientNo: policy.policyNo.jointInsuredCode }]);
            // console.log('GetClientPersonalInfo res', res);
            clientInfo['ownerNo'] = res[0]['data']['clientInfo'];
            clientInfo['insuredCode'] = res[1]['data']['clientInfo'];
            clientInfo['jointInsuredCode'] = res[2]['data']['clientInfo'];
            result.push(clientInfo);
          } catch (err) {
            this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
          }
        }
        for (let i = 0; i < policies[0]['data']['policy'].length; i++) {
          policies[0]['data']['policy'][i]['clientInfo'] = result[i];
        }
        // console.log('policies with clientInfo ', policies)
        loader.dismiss();
        this.updateStore('f03', policies.map(e => e.data));
      } else {
        const policyNo = policies[0]['data']['policy'].map(policy => {
          return {
            policyNo: {
              ownerNo: policy['policyInfoView']['ownerNo'],
              insuredCode: policy['policyInfoView']['insuredCode']
            }
          };
        });
        const result = [];
        console.log('GetClientPersonalInfo policyNo', policyNo);
        loader.present();
        for (const policy of policyNo) {
          try {
            const clientInfo = {};
            const res = await this.apiService.apiCall(['/ClientInfoContent/GetClientPersonalInfo', '/ClientInfoContent/GetClientPersonalInfo'], [{ clientNo: policy.policyNo.ownerNo }, { clientNo: policy.policyNo.insuredCode }]);
            // console.log('GetClientPersonalInfo res', res);
            clientInfo['ownerNo'] = res[0]['data']['clientInfo'];
            clientInfo['insuredCode'] = res[1]['data']['clientInfo'];
            result.push(clientInfo);
          } catch (err) {
            this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
          }
        }
        for (let i = 0; i < policies[0]['data']['policy'].length; i++) {
          policies[0]['data']['policy'][i]['clientInfo'] = result[i];
        }
        // console.log('policies with clientInfo ', policies)
        loader.dismiss();
        this.updateStore('f03', policies.map(e => e.data));
      }
    } catch (err) {
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      loader.dismiss();
    }
  }

  async get_f04_policy_transaction(policyNo) {
    console.log(`get_f04_policy_transaction: `);
    try {
      const res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetMyPolicies'
      ], [{ policyNo: policyNo }]);
      console.log('GetMyPolicies', res);
      this.updateStore('f04', res.map(e => e.data));
      // await this.f04_get_transaction_records_for_past_12_months(res[0]['data']['policy'][0]['policyInfoView']['policyNo']);
    } catch (err) {
      console.log(`get_f04_policy_transaction err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async f04_get_transaction_records_for_past_12_months(policyNo) {
    console.log(`f04_get_transaction_records_for_past_12_months: `);
    try {
      const res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetTransactionRecordsForPreviousTwelveMonths'
      ], [{ policyNo: policyNo }]);
      this.updateStore('f04-past-transaction', res.map(e => e.data));
    } catch (err) {
      console.log(`f04_get_transaction_records_for_past_12_months err: `, err);
      this.updateStore('f04-past-transaction', []);
    }
  }

  async f04_get_dividend_account_summary(policyNo) {
    console.log(`f04_get_dividend_account_summary: `);

    if (policyNo.length < 12) {
      return this.updateStore('f04-dividend-account-summary', []);
    }

    try {
      const res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetPolicyIncomeFundDividendAccountSummaryByPolicyNo'
      ], [{policyNo: policyNo, username: this.state.getValue().user.username, }]);
      this.updateStore('f04-dividend-account-summary', res.map(e => e.data));
    } catch (err) {
      console.log(`f04_get_dividend_account_summary err: `, err);
      this.updateStore('f04-dividend-account-summary', []);
    }

  }

  async get_g01_switching(policyNo) {
    console.log(`get_g01_switching: `);
    try {
      // return await this.stubdataService.getCall('/h01_redirection');
      const res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetSwitchInOrRedirectionPolicies'
      ], [{ listType: 'SW', policyNo: policyNo }]);
      res[0]['data']['policy'] = res[0]['data']['policy'].filter(policy => policy['policyInfoView']['policyValueInHKD'] > 0);
      this.updateStore('g01', res.map(e => e.data));
      if (res[0]['data']['policy'].length > 0) {
        const policy = res[0]['data']['policy'][0];
        // await this.get_g01_get_pending_transaction(policy['policyInfoView']['policyNo']);
        if (policy['policyAccountView'].length > 0) {
          // Workitem 391
          await this.get_g01_get_pending_transaction(policy['policyInfoView']['policyNo'], policy['policyAccountView'][0]['policyAcctNo'], policy['policyAccountView'][0]['policySubAcctNo']);
          await this.get_g01_chart_and_table(policy['policyInfoView']['policyNo'], policy['policyAccountView'][0]['policyAcctNo'], policy['policyAccountView'][0]['policySubAcctNo']);
        }
      }
    } catch (err) {
      console.log(`get_g01_switching err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_g01_get_pending_transaction(policyNo, coverageNo, accountType) {
    try {
      const res: any = await this.apiService.apiCall([
        // Workitem 391
        // '/PolicyInfoContent/GetPendingTransactions'
        '/PolicyInfoContent/GetPendingSwitchOutTransactions'
      ],
        [
          // Workitem 391
          // { policyNo: policyNo }
          { policyNo: policyNo, coverageNo: coverageNo, accountType: accountType }
        ]);
      this.updateStore('g01-update-pending-transactions', res[0]['data']['policyPendingTransactionsList']);
    } catch (err) {
      this.updateStore('g01-update-pending-transactions', []);
      // throw err;
    }
  }

  async get_g01_chart_and_table(policyNo, coverageNo, accountType) {
    try {
      let res: any = await this.apiService.apiCall([
        // '/PolicyInfoContent/GetPolicyCoverageBalanceList'
        '/PolicyInfoContent/GetPolicyCoverageBalanceListForCashAccountAndNonCashAccount',
        '/PolicyInfoContent/GetPolicySwitchOutList'
      ],
        [
          { policyNo: policyNo, coverageNo: coverageNo, accountType: accountType },
          { policyNo: policyNo, coverageNo: coverageNo, accountType: accountType }
        ]);
      res = res.map(e => e.data);
      this.updateStore('g01-update-chart-and-table', {
        tableData: res[0],
        chartData: res[0],
        newTableData: res[1]
      });
    } catch (err) {
      console.log('get_g01_chart_and_table', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      this.updateStore('g01-update-chart-and-table', {
        tableData: [],
        chartData: [],
        newTableData: []
      });
      // throw err;
    }
  }

  async get_g01b_fund_manager_list(policyNo) {
    try {
      let res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetPolicySwitchInFundManagerList',
      ], [{ policyNo: policyNo }]);
      res = res[0]['data']['fundHouseList'];
      this.updateStore('g01b-set-fund-manager-list', res);
    } catch (err) {
      console.log('get_g01b_fund_manager_list', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
    }
  }

  async get_g01b_fund_list(policyNo, fundHouseCode) {
    try {
      let res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetPolicySwitchInFundList',
      ], [{ policyNo: policyNo, fundHouseCode: fundHouseCode }]);
      res = res[0]['data']['fundList'];
      this.updateStore('g01b-set-fund-list', res);
    } catch (err) {
      console.log('get_g01b_fund_list', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
    }
  }

  async get_g01b_fund_info2(policyNo, fundCode) {
    try {
      const res = await this.apiService.apiCall([
        '/PolicyInfoContent/GetPolicySwitchInFundList'
      ], [{policyNo: policyNo, fundCode: fundCode }]);
      return res[0]['data']['fundList'][0];
    } catch (err) {
      console.log('get_g01b_fund_info2', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
    }
  }

  async g01a_pre_switching_action(policyNo, fundList) {
    try {
      let res: any = await this.apiService.apiCall([
        '/FundTransactions/PreSwitchingAction'
      ], [{ policyNo: policyNo, fundList: fundList }]);
      res = res[0]['data']['newTransactionNo'];
      this.updateStore('g01-pre-redirection-action', res);
    } catch (err) {
      console.log('g01a_pre_switching_action', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }


  async g02_switching_action(policyNo, accountNo, subAccountNo, emailAddress, transactionNo, switchOutList, switchInList, rpqEffectiveDate, riskScore, flgMismatch, flgRPQExpired, flgRPQNeverSubmit, flgFundRiskLevelExceed, flgDeclaration) {
    try {
      await this.apiService.apiCall([
        '/FundTransactions/SwitchingAction'
      ], [
        {
          policyNo: policyNo,
          accountNo: accountNo,
          subAccountNo: subAccountNo,
          emailAddress: emailAddress,
          transactionNo: transactionNo,
          switchOutList: switchOutList,
          switchInList: switchInList,
          rpqEffectiveDate: rpqEffectiveDate,
          riskScore: riskScore,
          flgMismatch: flgMismatch,
          flgRPQExpired: flgRPQExpired,
          flgRPQNeverSubmit: flgRPQNeverSubmit,
          flgFundRiskLevelExceed: flgFundRiskLevelExceed,
          flgDeclaration: flgDeclaration
        }
      ]);
    } catch (err) {
      console.log(`g02_switching_action err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_g03_switching_completed() {
    console.log(`get_g03_switching_completed: `);
    try {
      return await this.stubdataService.getCall('/g03_switching_completed');
    } catch (err) {
      console.log(`get_g03_switching_completed err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_h01_redirection(policyNo) {
    console.log(`get_h01_redirection: `);
    try {
      // return await this.stubdataService.getCall('/h01_redirection');
      const res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetSwitchInOrRedirectionPolicies'
      ], [{ listType: 'PR', policyNo: policyNo }]);
      this.updateStore('h01', res.map(e => e.data));
      if (res[0]['data']['policy'].length > 0) {
        const policy = res[0]['data']['policy'][0];
        if (policy['policyAccountView'].length > 0) {
          await this.get_h01_chart_and_table(policy['policyInfoView']['policyNo'], policy['policyAccountView'][0]['policyAcctNo'], policy['policyAccountView'][0]['policySubAcctNo']);
        }
      }
    } catch (err) {
      console.log(`get_h01_redirection err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_h01_chart_and_table(policyNo, coverageNo, accountType) {
    try {
      let res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetPolicyCoverageFundAllocationList',
        // '/PolicyInfoContent/GetPolicyCoverageBalanceList'
      ],
        [
          { policyNo: policyNo, coverageNo: coverageNo },
          // { policyNo: policyNo, coverageNo: coverageNo, accountType: accountType }
        ]);
      res = res.map(e => e.data);
      this.updateStore('h01-update-chart-and-table', {
        tableData: res[0],
        chartData: res[0]
      });
    } catch (err) {
      console.log('get_h01_chart_and_table', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      this.updateStore('h01-update-chart-and-table', {
        tableData: [],
        chartData: []
      });
      // throw err;
    }
  }

  async get_h01a_fund_manager_list(policyNo) {
    try {
      let res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetPolicyRedirectionFundManagerList',
      ], [{ policyNo: policyNo }]);
      res = res[0]['data']['fundHouseList'];
      this.updateStore('h01a-set-fund-manager-list', res);
    } catch (err) {
      console.log('get_h01a_future_investment_detail', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
    }
  }

  async get_h01a_fund_list(policyNo, fundHouseCode) {
    try {
      let res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetPolicyRedirectionFundList',
      ], [{ policyNo: policyNo, fundHouseCode: fundHouseCode }]);
      res = res[0]['data']['fundList'];
      this.updateStore('h01a-set-fund-list', res);
    } catch (err) {
      console.log('get_h01a_future_investment_detail', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
    }
  }

  async get_h01a_fund_info2(policyNo, fundCode) {
    try {
      const res = await this.apiService.apiCall([
        '/PolicyInfoContent/GetPolicyRedirectionFundList'
      ], [{policyNo: policyNo, fundCode: fundCode }]);
      return res[0]['data']['fundList'][0];
    } catch (err) {
      console.log('get_h01a_fund_info2', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
    }
  }

  async h01a_pre_redirection_action(policyNo, fundList) {
    try {
      let res: any = await this.apiService.apiCall([
        '/FundTransactions/PreRedirectionAction'
      ], [{ policyNo: policyNo, fundList: fundList }]);
      res = res[0]['data']['newTransactionNo'];
      this.updateStore('h01-pre-redirection-action', res);
    } catch (err) {
      console.log('h01a_pre_redirection_action', err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_h02_redirection_data_confirmation() {
    console.log(`get_h02_redirection_data_confirmation: `);
    try {
      return await this.stubdataService.getCall('/h02_redirection_dataconfirmation');
    } catch (err) {
      console.log(`get_h02_redirection_data_confirmation err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async h02_redirection_action(policyNo, accountNo, subAccountNo, emailAddress, transactionNo, fundList, rpqEffectiveDate, riskScore, flgMismatch, flgRPQExpired, flgRPQNeverSubmit, flgFundRiskLevelExceed, flgDeclaration) {
    try {
      await this.apiService.apiCall([
        '/FundTransactions/RedirectionAction'
      ], [
        {
          policyNo: policyNo,
          accountNo: accountNo,
          subAccountNo: subAccountNo,
          emailAddress: emailAddress,
          transactionNo: transactionNo,
          fundList: fundList,
          rpqEffectiveDate: rpqEffectiveDate,
          riskScore: riskScore,
          flgMismatch: flgMismatch,
          flgRPQExpired: flgRPQExpired,
          flgRPQNeverSubmit: flgRPQNeverSubmit,
          flgFundRiskLevelExceed: flgFundRiskLevelExceed,
          flgDeclaration: flgDeclaration
        }
      ]);
    } catch (err) {
      console.log(`get_h02_redirection_data_confirmation err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_h03_redirection_completed() {
    console.log(`get_h03_redirection_completed: `);
    try {
      return await this.stubdataService.getCall('/h03_redirection_completed');
    } catch (err) {
      console.log(`get_h03_redirection_completed err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async delete_session_transaction_async(policyNo) {
    try {
      await this.apiService.apiCall([
        '/FundTransactions/DeleteSessionTransactionAsync'
      ], [
        {
          policyNo: policyNo,
          // crossdomain: true
          // headers: {'Access-Control-Allow-Origin': '*'}
        }
      ]);
    } catch (err) {
      console.log(`delete_session_transaction_async err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_i01_my_documents() {
    console.log(`get_i01_my_documents: `);
    let pleaseWaitMessage = 'Please wait...';
    this.translate.get(['GEN_01']).subscribe(i18n => {
      pleaseWaitMessage = i18n.GEN_01;
    });
    const loader = await this.loadingController.create({
      message: pleaseWaitMessage
    });
    try {
      const policies: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetMyPolicies'
      ]);
      const policyNo = policies[0]['data']['policy'].map(policy => {
        return {
          policyNo: policy['policyInfoView']['policyNo']
        };
      });
      const result = [];
      loader.present();
      for (const policy of policyNo) {
        try {
          const res = await this.apiService.apiCall(['/PolicyInfoContent/GetPolicyEstatementList'], [policy]);
          result.push(res[0]['data']['policyEStatement']);
        } catch (err) { }
      }
      loader.dismiss();
      this.updateStore('i01', _.flatten(result));
    } catch (err) {
      loader.dismiss();
    }
  }

  async i01_update_read_status(payload) {
    try {
      return await this.apiService.apiCall(['/SystemTransactions/UpdateEStatementReadStatus'], [payload]);
    } catch (err) {
      console.log(`i01_update_read_status err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_ib01_video_list() {
    console.log(`ib01_get_video_list: `);
    try {
      const res: any = await this.apiService.apiCall(['/CMS/video-pages'], []);
      console.log('ib01_get_video_list', res);
      this.updateStore('ib01', res[0].data);
    } catch (err) {
      console.log(`ib01_get_video_list err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_j01_my_protection() {
    try {
      const res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetMyPolicies'
      ]);
      console.log('GetMyPolicies j01', res);
      const storeRes = [];
      res.forEach(e => {
        storeRes.push(e.data);
      });
      this.updateStore('j01', storeRes);
    } catch (err) {
      console.log(`get_j01_my_wealth err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_j02_protection_financial_summary() {
    console.log(`get_j02_protection_financial_summary: `);
    try {
      return await this.stubdataService.getCall('/j02_protection_financial_summary');
    } catch (err) {
      console.log(`get_j02_protection_financial_summary err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_j03_protection_policy_information() {
    console.log(`get_j03_protection_policy_information: `);
    try {
      const res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetMyPolicies',
        '/ClientInfoContent/GetClientPersonalInfo'
      ], [{}, { clientNo: this.state.getValue().user.clientNo }]);
      const storeRes = [];
      res.forEach(e => {
        storeRes.push(e.data);
      });
      this.updateStore('j03', storeRes);
    } catch (err) {
      console.log(`get_j03_protection_policy_information err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_k02_personal_information() {
    console.log(`get_k02_personal_information: `);
    try {
      const res: any = await this.apiService.apiCall([
        '/ClientInfoContent/GetClientPersonalInfo'
      ], [{ clientNo: this.state.getValue().user.clientNo }]);
      console.log('GetClientPersonalInfo', res);
      this.updateStore('k02', res[0].data);
    } catch (err) {
      console.log(`get_k02_personal_information err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async k03_update_personal_information(payload) {
    try {
      return await this.apiService.apiCall(['/UserTransactions/UpdatePersonalInformation'], [payload]);
    } catch (err) {
      console.log(`k03_update_personal_information err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async k04_update_password(payload) {
    try {
      return await this.apiService.apiCall(['/UserTransactions/UpdatePassword'], [payload]);
    } catch (err) {
      console.log(`k04_update_password err: `, err);
      this.presentAlert(err.response.status, err.response.data.errorMsg);
      throw err;
    }
  }

  async get_m02_notice_investment_choice() {
    console.log(`get_m02_notice_investment_choice: `);
    try {
      const res: any = await this.apiService.apiCall([
        '/Content/GetInvestmentChoiceNotice'
      ]);
      console.log('GetInvestmentChoiceNotice', res);
      this.updateStore('m02', res[0].data);
    } catch (err) {
      console.log(`get_m02_notice_investment_choice err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_m03_notice_latest_news() {
    console.log(`get_m03_notice_latest_news: `);
    try {
      const res: any = await this.apiService.apiCall([
        '/Content/GetLatestNews'
      ]);
      console.log('GetLatestNews', res);
      this.updateStore('m03', res[0].data);
    } catch (err) {
      console.log(`get_m03_notice_latest_news err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async n02_contact_us(payload) {
    console.log(`n02_contact_us: `);
    try {
      const res: any = await this.apiService.apiCall([
        '/GeneralTransactions/SendContactForm'
      ], [payload]);
      console.log('n02_contact_us', res);
      return res;
    } catch (err) {
      console.log(`n02_contact_us err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  async get_r01_top5_inflow_outflow_information() {
    console.log(`get_r01_top5_inflow_outflow_information: `);
    try {
      const fundFlowInfo = {};
      const res: any = await this.apiService.apiCall([
        '/PolicyInfoContent/GetTop5FundFlowSubscription', '/PolicyInfoContent/GetTop5FundFlowRedemption'
      ]);
      fundFlowInfo['inflowFundList'] = res[0]['data']['fundFlowList'];
      fundFlowInfo['outflowFundList'] = res[1]['data']['fundFlowList'];
      // console.log('GetTop5FundFlowSubscription', fundFlowInfo['inflowFundList']);
      // console.log('GetTop5FundFlowRedemption', fundFlowInfo['inoutflowFundListlowFundList']);
      this.updateStore('r01', fundFlowInfo);
    } catch (err) {
      console.log(`get_r01_top5_inflow_outflow_information err: `, err);
      this.presentAlert(err.response.status, err.response.data.returnStatus.errorMsg);
      throw err;
    }
  }

  updateStore(pageKey, payload) {
    const currentPage: any = this.state.getValue().navigation.currentPage;
    switch (pageKey) {
      case 'bg01':
        this.store.dispatch(new GoToPageBG01(payload));
        break;
      case 'bg02':
        this.store.dispatch(new GoToPageBG02(payload));
        break;
      case 'bg06':
        this.store.dispatch(new GoToPageBG06(payload));
        break;
      case 'bg07':
        this.store.dispatch(new GoToPageBG07(payload));
        break;
      case 'bg16':
        this.store.dispatch(new GoToPageBG16(payload));
        break;
      case 'bg20':
        this.store.dispatch(new GoToPageBG20(payload));
        break;
      case 'bg20-bg20-update-contribution-summary':
        this.store.dispatch(new UpdateBg20ContributionSummary(payload));
        break;
      case 'bg20-update-pending-transaction':
        this.store.dispatch(new UpdateBg20PendingTransaction(payload));
        break;
      case 'bg20-update-policy-fund-transaction-history':
        this.store.dispatch(new UpdateBg20TransactionHistory(payload));
        break;
      case 'bg20-update-contribution-summary':
        this.store.dispatch(new UpdateBg20ContributionSummary(payload));
        break;
      case 'bg20-update-account-table':
        this.store.dispatch(new UpdateBg20AccountTable(payload));
        break;
      case 'bk01':
        this.store.dispatch(new GoToPageBK01(payload));
        break;
      case 'bk02':
        this.store.dispatch(new GoToPageBK02(payload));
        break;
      case 'bk03':
        this.store.dispatch(new GoToPageBK03(payload));
        break;
      case 'bl01':
        this.store.dispatch(new GoToPageBL01(payload));
        break;
      case 'bl02':
        this.store.dispatch(new GoToPageBL02(payload));
        break;
      case 'bl03':
        this.store.dispatch(new GoToPageBL03(payload));
        break;
      case 'bl04':
        this.store.dispatch(new GoToPageBL04(payload));
        break;
      case 'bl05':
        this.store.dispatch(new GoToPageBL05(payload));
        break;
      case 'bl06':
        this.store.dispatch(new GoToPageBL06(payload));
        break;
      case 'bl07':
        this.store.dispatch(new GoToPageBL07(payload));
        break;
      case 'bm01':
        this.store.dispatch(new GoToPageBM01(payload));
        break;
      case 'a01':
        this.store.dispatch(new SetUser(payload));
        break;
      case 'f01':
        this.store.dispatch(new GoToPageF01(payload));
        break;
      case 'f02':
        this.store.dispatch(new GoToPageF02(payload, currentPage));
        break;
      case 'f02-update-chart-and-table':
        this.store.dispatch(new SetF02ChartAndTableData(payload));
        break;
      case 'f02-update-cash-table':
        this.store.dispatch(new SetF02CashTableData(payload));
        break;
      case 'f02-aspire-information':
        this.store.dispatch(new SetF02AspireInformation(payload));
        break;
      case 'f03':
        this.store.dispatch(new GoToPageF03(payload, currentPage));
        break;
      case 'f04':
        this.store.dispatch(new GoToPageF04(payload, currentPage));
        break;
      case 'f04-past-transaction':
        this.store.dispatch(new SetF04PastTransaction(payload, currentPage));
        break;
      case 'f04-dividend-account-summary':
          this.store.dispatch(new SetF04DividendAccountSummary(payload, currentPage));
        break;
      case 'g01':
        this.store.dispatch(new GoToPageG01(payload));
        break;
      case 'g01-update-pending-transactions':
        this.store.dispatch(new SetG01PendingTransaction(payload));
        break;
      case 'g01-update-chart-and-table':
        this.store.dispatch(new SetSwitchInChartAndTableData(payload));
        break;
      case 'g01b-set-fund-manager-list':
        this.store.dispatch(new SetSwitchInFundManagerList(payload));
        break;
      case 'g01b-set-fund-list':
        this.store.dispatch(new SetSwitchInFundList(payload));
        break;
      case 'g01-pre-redirection-action':
        this.store.dispatch(new SetSwitchInTransactionNo(payload));
        break;
      case 'h01':
        this.store.dispatch(new GoToPageH01(payload));
        break;
      case 'h01-update-chart-and-table':
        this.store.dispatch(new SetH01ChartAndTableData(payload));
        break;
      case 'h01a-set-fund-manager-list':
        this.store.dispatch(new SetFundManagerList(payload));
        break;
      case 'h01a-set-fund-list':
        this.store.dispatch(new SetFundList(payload));
        break;
      case 'h01-pre-redirection-action':
        this.store.dispatch(new SetTransactionNo(payload));
        break;
      case 'i01':
        this.store.dispatch(new GoToPageI01(payload));
        break;
      case 'ib01':
        this.store.dispatch(new GoToPageIB01(payload));
        break;
      case 'j01':
        this.store.dispatch(new GoToPageJ01(payload));
        break;
      case 'j03':
        this.store.dispatch(new GoToPageJ03(payload));
        break;
      case 'k02':
        this.store.dispatch(new GoToPageK02(payload));
        break;
      case 'm02':
        this.store.dispatch(new GoToPageM02(payload));
        break;
      case 'm03':
        this.store.dispatch(new GoToPageM03(payload));
        break;
      case 'r01':
        this.store.dispatch(new GoToPageR01(payload));
        break;
      default:
        break;
    }
  }

  async presentAlert(errorCode, errorMsg) {
    const tmpErrorCode = 'ERR_' + errorCode;
    let tmpMessage: any;
    const language = this.state.getValue().setting.language;
    // Fixed Workitem 425
    tmpMessage = errorMsg;
    if (errorCode === '520') {
      this.translate.get(tmpErrorCode).subscribe(res => {
        tmpMessage = res;
      });
    }
    if (language === 'tc') {
      const alert = await this.alertController.create({
        header: '錯誤提示',
        message: `代號: ${errorCode}` + '<br>' + `訊息: ${tmpMessage}`,
        buttons: ['確定']
      });
      await alert.present();
    } else {
      const alert = await this.alertController.create({
        header: 'Error Alert',
        message: `Code: ${errorCode}` + '<br>' + `Message: ${tmpMessage}`,
        buttons: ['OK']
      });
      await alert.present();
    }
  }

  async downloadDividendCalendar() {
    const language = this.state.getValue().setting.language;
    // const file = `assets/pdf/Dividend_Calendar_2025_(202503)_${language === 'en' ? 'Eng' : 'Chi'}.pdf`;
    const file = `assets/pdf/Dividend Calendar 2025 (202506)_${language === 'en' ? 'Eng' : 'Chi'}.pdf`;
    window.open(file, '_system');
  }

  async goToInvestPlatform(fundCode: string = '') {
    const lang = this.translate.currentLang;
    const token = await this.get_token('aqumon', this.state.getValue().user.username);

    // show redirect to external website message
    let pleaseWaitMessage = 'You are being redirected to an external website';
    this.translate.get(['N05_36']).subscribe(i18n => {
      pleaseWaitMessage = i18n.N05_36;
    });
    const loader = await this.loadingController.create({
      message: pleaseWaitMessage
    });
    loader.present();

    const timeout = setTimeout(async() => {
      clearTimeout(timeout);
      loader.dismiss();

      const url = environment.investplatform_url + '?clientId=' + this.state.getValue().user.username + '&token=' + token + '&lang=' + lang + (fundCode === '' ? '' : '&redirectFunction=toFundDetail&isinCode=' + fundCode);
      const newWin = window.open(url, '_system');
      if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
        await this.presentInPlusPopupWarning();
      }
    }, 2000);
  }

  async presentInPlusReminder(fundCode: string = '') {
    if (this.commonService.isMobile()) {
      const alert = await this.alertCtrl.create({
        header: this.translate.instant('INPLUS_01'),
        message: this.translate.instant('INPLUS_02'),
        buttons: [
          {
            text: this.translate.instant('INPLUS_03'),
            handler: async () => {
              await this.goToInvestPlatform(fundCode);
            },
          },
          {
            text: this.translate.instant('INPLUS_04'),
          }
        ],
      });
      await alert.present();
    } else {
      // Normal Desktop
      await this.goToInvestPlatform(fundCode);
    }
  }

    async presentInPlusPopupWarning() {
    const alert = await this.alertCtrl.create({
      message: this.translate.instant('INPLUS_05'),
      buttons: [
        {
          text: this.translate.instant('INPLUS_03')
        }
      ]
    });

    await alert.present();
  }
}
